module.exports = __webpack_public_path__ + "static/media/saphir-mockup.563ca97d.png";